module.exports = __webpack_public_path__ + "media/components/listings/search/SearchBar/SearchBarButtons/MobileFilter/icon-a45abd0a06621ea7280338e0301cb5b8.svg";